<template>
  <f7-page>
    <div class="mx-auto w-11/12 sm:w-9/12 sm:min-w-150 mt-2 sm:mt-12 max-w-4xl text-center">
      <img
        class="w-64 mx-auto"
        src="@/assets/files.svg"
        alt="account"
      >
      <div class="text-2xl my-4">
        Estamos creando tu cuenta...
      </div>
      <svg
        id="loader"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="50"
          cy="50"
          r="45"
        />
      </svg>
    </div>
  </f7-page>
</template>

<script>
import * as axios from 'axios'
import { mapState } from 'vuex'
import { storageAvailable } from '../utils/navigatorApi'
export default {
  computed: {
    isCreate () {
      let create = false
      if (storageAvailable('localStorage')) {
        create = localStorage.getItem('isCreate') || false
      }
      return create
    },
    ...mapState({
      uid: state => state.auth.uid,
      account: state => state.auth.account,
    }),
  },
  watch: {
    account: function (newVal) {
      if (typeof newVal.phoneNumber !== 'undefined') {
        this.$f7router.navigate('/', { reloadAll: true })
      }
    },
  },
  async mounted () {
    try {
      if (this.isCreate) {
        const response = await axios({
          url: '/users/initiateCreation',
          method: 'POST',
          data: {
            uid: this.uid,
          },
        })
        localStorage.removeItem('isCreate')
        console.info(response)
      }
    } catch (err) {
      console.error(err)
    }
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";
#loader {
  animation: 2s linear infinite svg-animation;
  max-width: 50px;
  margin: 0 auto 20px auto;
}

// SVG animation.
@keyframes svg-animation {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg)
  }
}

// Circle styles.
circle {
  animation: 1.4s ease-in-out infinite both circle-animation;
  display: block;
  fill: transparent;
  stroke: $primary-color;
  stroke-linecap: round;
  stroke-dasharray: 283;
  stroke-dashoffset: 280;
  stroke-width: 10px;
  transform-origin: 50% 50%;
}

// Circle animation.
@keyframes circle-animation {
  0%,
  25% {
    stroke-dashoffset: 280;
    transform: rotate(0);
  }
  50%,
  75% {
    stroke-dashoffset: 75;
    transform: rotate(45deg);
  }
  100% {
    stroke-dashoffset: 280;
    transform: rotate(360deg);
  }
}
</style>
